import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Logo = () => {
    return (
        <>
            <div className={styles.logo}>
                <div className={styles.logoBox}>
                    <img
                        className={styles.fengIcon}
                        src="https://x0.ifengimg.com/ucms/2022_47/A1AACF0B13B31F3525E84E1FC3193AFE62B77951_size23_w700_h56.png"
                    />
                    <img
                        className={styles.zggdIcon}
                        src="https://x0.ifengimg.com/ucms/2022_47/F14B94B3C1BF691CBDC01725D2A4A4101828671B_size10_w336_h64.png"
                    />
                </div>
            </div>
            <img
                className={styles.logoBg}
                src="https://x0.ifengimg.com/ucms/2022_47/07CF92B600F9A86A85893185F246F954FEE71348_size345_w5120_h1000.png"
            />
        </>
    );
};

export default errorBoundary(Logo);
